module.exports = __webpack_public_path__ + "img/overview.17209ffb.svg";